import { render, staticRenderFns } from "./TabCalls.vue?vue&type=template&id=59e6a4dc&"
import script from "./TabCalls.vue?vue&type=script&lang=js&"
export * from "./TabCalls.vue?vue&type=script&lang=js&"
import style0 from "./TabCalls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports